import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

const BANNER_DISMISSED_KEY = "directory_connection_banner_dismissed";

export function ConnectionBanner() {
  const [isDismissed, setIsDismissed] = useState(true);

  useEffect(() => {
    // Check session storage on mount
    const dismissed = sessionStorage.getItem(BANNER_DISMISSED_KEY);
    setIsDismissed(dismissed === "true");
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem(BANNER_DISMISSED_KEY, "true");
    setIsDismissed(true);
  };

  if (isDismissed) return null;

  return (
    <Card className="bg-primary/5 border-primary/20">
      <CardContent className="flex items-center justify-between gap-4 p-4">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Users className="h-5 w-5 text-primary" />
          </div>
          <div className="space-y-1">
            <p className="text-sm font-medium">
              👋 Connect with mentors and entrepreneurs to see their full profiles and unlock collaboration features
            </p>
            <Button variant="link" size="sm" className="h-auto p-0 text-primary" asChild>
              <Link to="/connections">View your connections →</Link>
            </Button>
          </div>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 flex-shrink-0"
          onClick={handleDismiss}
        >
          <X className="h-4 w-4" />
        </Button>
      </CardContent>
    </Card>
  );
}
